import React from 'react';

export const SeccionDocumento = ({ data }) => {
    return (
        <>
            <span style={{fontSize: '9pt'}}><strong>Datos de Documentación Legal</strong></span>
            <br />
            <table style={{width: '100%', borderCollapse: 'collapse', border: 'none', marginTop: '10px'}}>
                <tr>
                    <td style={{border:'none', borderTopLeftRadius: '5px', borderCollapse: 'collapse', width:'80%', padding: '5px', color: '#fff', backgroundColor: '#636A73'}}>Documento</td>
                    <td style={{border:'none', borderTopRightRadius: '5px', borderCollapse: 'collapse', width:'20%', padding: '5px', color: '#fff', backgroundColor: '#636A73', textAlign: 'right'}}>Existe</td>
                </tr>           
                {data.map((documento) => (
                    <tr>
                        <td style={{border:'none', borderCollapse: 'collapse', borderLeft: '1pt solid #dcdcdc', borderBottom: '1pt solid #dcdcdc'}}>{documento.documento}</td>
                        <td style={{border:'none', borderCollapse: 'collapse', borderRight: '1pt solid #dcdcdc', borderBottom: '1pt solid #dcdcdc', textAlign: 'right'}}>{documento.existe}</td>
                    </tr>
                ))}
            </table>
        </>
    )
}